import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Button from '../../components/Button/Button';
import LiquidGlassCard from '../../components/LiquidGlassCard/LiquidGlassCard';
import './Auth.css';

const Auth = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, pendingRental, clearPendingRental } = useAuth();

  const [isSignUp, setIsSignUp] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isAuthenticated()) {
      if (pendingRental) {
        navigate('/services');
      } else {
        navigate('/');
      }
    }
  }, [isAuthenticated, pendingRental, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const endpoint = isSignUp ? '/v1/auth/register' : '/v1/auth/login';
      const response = await api.post(endpoint, {
        email: formData.email,
        password: formData.password
      });

      if (response?.token) {
        login(response.user || { email: formData.email }, response.token);

        if (pendingRental) {
          navigate('/services');
        } else {
          navigate('/');
        }
      }
    } catch (err) {
      setError(err.message || 'Authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = () => {
    // Build callback URL for after Google authentication
    const callbackUrl = `${window.location.origin}/auth/callback`;

    // Redirect to Google OAuth endpoint with callback URL
    const googleAuthUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/auth/google/web?callbackUrl=${encodeURIComponent(callbackUrl)}`;
    window.location.href = googleAuthUrl;
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <LiquidGlassCard className="auth-card">
          {/* Header */}
          <div className="auth-header">
            <h1 className="auth-title">
              Welcome to OpenSMS
            </h1>
            <p className="auth-subtitle">
              Access temporary numbers for secure SMS verification.
            </p>
            {pendingRental && (
              <div className="auth-pending-notice">
                <span className="material-symbols-outlined">info</span>
                <span>Sign in to continue with your SMS rental</span>
              </div>
            )}
          </div>

          {/* Error Message */}
          {error && (
            <div className="auth-error">
              <span className="material-symbols-outlined">error</span>
              <span>{error}</span>
            </div>
          )}

          {/* Google Sign In */}
          <div className="auth-social">
            <button className="social-btn" onClick={handleGoogleSignIn} type="button">
              <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <span>Sign in with Google</span>
            </button>
          </div>

          {/* Divider */}
          {/* <div className="auth-divider">
            <div className="auth-divider-line"></div>
            <span className="auth-divider-text">or</span>
            <div className="auth-divider-line"></div>
          </div> */}

          {/* Email/Password Form - commented out, only Google sign in */}
          {/* <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-input"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="checkbox-input"
                  disabled={loading}
                />
                <span>Remember me</span>
              </label>
              {!isSignUp && (
                <a href="#" className="forgot-link">
                  Forgot your password?
                </a>
              )}
            </div>

            <Button type="submit" variant="primary" fullWidth size="large" disabled={loading}>
              {loading ? (
                <span className="loading-text">
                  <span className="spinner"></span>
                  {isSignUp ? 'Creating Account...' : 'Signing In...'}
                </span>
              ) : (
                isSignUp ? 'Sign Up with Email' : 'Sign In with Email'
              )}
            </Button>
          </form> */}

          {/* Toggle Sign In/Sign Up */}
          {/* <p className="auth-toggle">
            {isSignUp ? 'Already have an account?' : "Don't have an account?"}
            {' '}
            <button
              type="button"
              className="auth-toggle-btn"
              onClick={() => {
                setIsSignUp(!isSignUp);
                setError('');
              }}
              disabled={loading}
            >
              {isSignUp ? 'Sign In' : 'Sign Up'}
            </button>
          </p> */}

          {/* Privacy Notice */}
          <div className="auth-privacy">
            <span className="material-symbols-outlined">lock</span>
            <p>Your privacy is our priority. We never share your data.</p>
          </div>
        </LiquidGlassCard>
      </div>
    </div>
  );
};

export default Auth;
